import { Required } from '@decorators/entity-required.decorator';
import { Primary } from '@decorators/entity-primary.decorator';
import { PhraseDommage } from './phrase-dommage.class';
import { Phrase } from './phrase.class';
import { Rapport } from './rapport.class';
import { RapportInvestigation } from './rapport-investigation.class';
import { QuestionRapport } from './question-rapport.class';
import { Photo } from './photo.class';
import { PhraseWorkflow } from './phrase-workflow.class';
import { v4 as uuidv4 } from 'uuid';

export enum ColorType {
	RED = 'red',
	BLUE = 'blue',
	NONE = 'none',
}

/**
 * Structure des données saisies dans un workflow
 */
export interface WorkflowData {
	/** Valeurs des variables (nodeId → valeur) */
	values: Record<string, string | string[] | number | null>;
	/** Couleurs assignées par l'utilisateur (pour options triggersColorQuestion) */
	colorAssignments: {
		red: string[];   // ["nodeId:optionValue", ...]
		blue: string[];
	};
	/** IDs des PhraseRapport d'investigation couvertes par cette conclusion/remarque */
	coveredPhraseIds?: string[];
	/** Options libres marquées manuellement comme déclencheur de couleur (mode 'ask') */
	freeOptionColorTriggers?: Record<string, boolean>;  // "nodeId:optionValue" → true/false
	/** Forcer l'affichage des noms de pièces (sans compression vers le logement) */
	forcePiece?: boolean;
	/** Forcer l'affichage des noms de supports (sans compression vers la pièce) */
	forceSupport?: boolean;
	/** Valeurs préco personnalisées pour les options libres ("nodeId:optionValue" → texte préco) */
	customPrecoValues?: Record<string, string>;
}


export class PhraseRapport {
	@Required
	@Primary
	id: string;

	@Required
	rapport: Rapport;

	investigation: RapportInvestigation;
	investigationId: string;

	// phraseDommage: PhraseDommage;
	phraseDommageId: number;
	parentPhraseRapportId: string;

	@Required
	phrase: Phrase;
	phraseId: number;

	questions: QuestionRapport[];

	manualPhotos?: Photo[];

	@Required
	done: boolean;

	color: ColorType;

	redcolors: string[];
	bluecolors: string[];
	render: string;
	renderNoHtml: string;
	isLocked: boolean;
	priorityQuestion: string;
	combinedValue: string;
	
	isConclusion: boolean;
	isRemarque: boolean;
	
	// Flag local (non persisté) pour indiquer que la phrase source a été modifiée
	dirty?: boolean;

	@Required
	sort: number;

	// ========================================
	// NOUVEAU SYSTÈME WORKFLOW
	// ========================================

	/**
	 * Lien vers le PhraseWorkflow utilisé (version spécifique)
	 * Si défini, on utilise le nouveau système workflow
	 */
	phraseWorkflow?: PhraseWorkflow;
	phraseWorkflowId?: number;

	/**
	 * Données saisies par l'utilisateur dans le workflow
	 */
	workflowData?: WorkflowData;

	// ========================================

	constructor() {	
		if (!this.id) this.id = uuidv4();
	}

	/**
	 * Vérifie si cette phrase utilise le nouveau système workflow
	 */
	isWorkflowBased(): boolean {
		return !!this.phraseWorkflowId;
	}
}